
import {defineComponent} from "vue";
import InputCheckboxBoolean from "@/components/UI/InputCheckboxBoolean.vue";
import {toInitCapitalize} from "@/helpers/functions/string";

export default defineComponent({
  name: "ProductSelectionBaseItem",
  emits: ["update"],
  components: {InputCheckboxBoolean},
  props: {
    productSelectionBase: {
      type: Object,
      required: true
    },
    itemId: {
      type: String,
      required: true
    },
    itemDescriptionKey: {
      type: String,
      required: true
    },
    errors: {
      type: Object
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    item: {
      get(): boolean {
        // console.log('getting... ' + this.itemId + ':', this.getProductSelectionBase[this.itemId])
        return this.productSelectionBase[this.itemId];
      },
      set(value: boolean) {
        this.$emit('update', this.itemId, value);
      }
    },
    itemName(): string {
      return this.itemId.replaceAll('_', '-');
    },
  },
  methods: {
    toInitCapitalize
  }
});
